export const CHECKOUT_LINKS = {
  base: 'https://librofy-store.impultienda.ar/checkout/plan-basico',
  completo: 'https://librofy-store.impultienda.ar/checkout/plan-pro',
} as const
